var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDatalayer(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 14.75C21.2426 14.75 22.25 13.7426 22.25 12.5C22.25 11.2574 21.2426 10.25 20 10.25C18.7574 10.25 17.75 11.2574 17.75 12.5C17.75 13.7426 18.7574 14.75 20 14.75Z",
    fill: "#B2DDFF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20 6.75C21.2426 6.75 22.25 5.74264 22.25 4.5C22.25 3.25736 21.2426 2.25 20 2.25C18.7574 2.25 17.75 3.25736 17.75 4.5C17.75 5.74264 18.7574 6.75 20 6.75Z",
    fill: "#B2DDFF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20 22.75C21.2426 22.75 22.25 21.7426 22.25 20.5C22.25 19.2574 21.2426 18.25 20 18.25C18.7574 18.25 17.75 19.2574 17.75 20.5C17.75 21.7426 18.7574 22.75 20 22.75Z",
    fill: "#B2DDFF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M4 14.75C5.24264 14.75 6.25 13.7426 6.25 12.5C6.25 11.2574 5.24264 10.25 4 10.25C2.75736 10.25 1.75 11.2574 1.75 12.5C1.75 13.7426 2.75736 14.75 4 14.75Z",
    fill: "#B2DDFF"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M19 13.25C19.41 13.25 19.75 12.91 19.75 12.5C19.75 12.09 19.41 11.75 19 11.75H11.75V7.5C11.75 5.92 12.42 5.25 14 5.25H19C19.41 5.25 19.75 4.91 19.75 4.5C19.75 4.09 19.41 3.75 19 3.75H14C11.58 3.75 10.25 5.08 10.25 7.5V11.75H5C4.59 11.75 4.25 12.09 4.25 12.5C4.25 12.91 4.59 13.25 5 13.25H10.25V17.5C10.25 19.92 11.58 21.25 14 21.25H19C19.41 21.25 19.75 20.91 19.75 20.5C19.75 20.09 19.41 19.75 19 19.75H14C12.42 19.75 11.75 19.08 11.75 17.5V13.25H19Z",
    fill: "#B2DDFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDatalayer);
export default __webpack_public_path__ + "static/media/Datalayer.ff0c7dcee34103b1851b46e1083c3d60.svg";
export { ForwardRef as ReactComponent };